import { render, staticRenderFns } from "./claimInfo.vue?vue&type=template&id=2492a556&scoped=true"
import script from "./claimInfo.vue?vue&type=script&lang=js"
export * from "./claimInfo.vue?vue&type=script&lang=js"
import style0 from "./claimInfo.vue?vue&type=style&index=0&id=2492a556&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2492a556",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2492a556')) {
      api.createRecord('2492a556', component.options)
    } else {
      api.reload('2492a556', component.options)
    }
    module.hot.accept("./claimInfo.vue?vue&type=template&id=2492a556&scoped=true", function () {
      api.rerender('2492a556', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/examine/claimRecordManage/claimInfo.vue"
export default component.exports